"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _moment = _interopRequireDefault(require("moment"));

var _lang = _interopRequireDefault(require("./lang"));

var _useCalendarReducer2 = _interopRequireDefault(require("./useCalendarReducer"));

var _palette = require("../../../../styles/palette");

var buildWeekItems = function buildWeekItems(language) {
  var weekKey = 0;
  return (0, _toConsumableArray2["default"])(new Array(7)).map(function (_, i) {
    weekKey += 1;
    return {
      key: weekKey,
      label: (0, _moment["default"])().locale(language).isoWeekday(i + 1).format(_lang["default"][language].weekday)
    };
  });
};

var buildCalendarItems = function buildCalendarItems(_ref) {
  var month = _ref.month,
      min = _ref.min,
      updateDay = _ref.updateDay,
      daySelected = _ref.daySelected;
  var last = month.clone().endOf('month').endOf('isoWeek');
  var day = month.clone().startOf('isoWeek');

  var buildOnClick = function buildOnClick(date, nextMonth) {
    return function (e) {
      e.stopPropagation();
      updateDay(date, nextMonth ? month.clone().add(1, 'month') : month);
    };
  };

  var calendar = [];
  var i = 1;

  while (day.isSameOrBefore(last)) {
    var disabled = !day.clone().startOf('month').isSame(month) || min && day.isBefore(min);
    var nextMonth = day.clone().startOf('month').isSame(month.clone().add(1, 'month'));
    calendar.push({
      type: 'day',
      disabled: disabled,
      current: day.startOf('day').format('YYYY-MM-DD') === daySelected,
      onClick: buildOnClick(day.format('YYYY-MM-DD'), nextMonth),
      key: day.startOf('day').format('YYYY-MM-DD'),
      nextMonth: nextMonth,
      label: day.date().toString()
    });

    if (i % 7 === 0) {
      calendar.push({
        type: 'br',
        key: "br-".concat(i)
      });
    }

    day.add(1, 'days');
    i += 1;
  }

  return calendar;
};

var useCalendar = function useCalendar(_ref2) {
  var value = _ref2.value,
      language = _ref2.language,
      min = _ref2.min,
      handleSelect = _ref2.handleSelect,
      handleChange = _ref2.handleChange,
      handleFocus = _ref2.handleFocus;

  var _useCalendarReducer = (0, _useCalendarReducer2["default"])({
    value: value,
    language: language
  }),
      active = _useCalendarReducer.active,
      daySelected = _useCalendarReducer.daySelected,
      dirty = _useCalendarReducer.dirty,
      currentValue = _useCalendarReducer.currentValue,
      month = _useCalendarReducer.month,
      dispatch = _useCalendarReducer.dispatch;

  var updateDay = (0, _react.useCallback)(function (newDaySelected, newMonth) {
    dispatch({
      type: 'UPDATE_DAY',
      payload: {
        daySelected: newDaySelected,
        month: newMonth
      }
    });
  }, [dispatch]);
  var weekItems = (0, _react.useMemo)(function () {
    return buildWeekItems(language);
  });
  var calendarItems = buildCalendarItems({
    month: month,
    min: min,
    updateDay: updateDay,
    daySelected: daySelected
  });
  var onChange = (0, _react.useCallback)(function (e) {
    if (handleChange) {
      handleChange();
    }

    dispatch({
      type: 'SET_DIRTY',
      payload: e.target.value !== ''
    });
  }, [dispatch, handleChange]);

  var onFocus = function onFocus() {
    if (handleFocus) {
      handleFocus();
    }

    dispatch({
      type: 'ON_FOCUS'
    });
  };

  var currentStatus = (0, _react.useMemo)(function () {
    if (active) {
      return {
        status: 'active',
        color: _palette.palette.link
      };
    }

    if (dirty) {
      return {
        status: 'dirty',
        color: _palette.palette.bobBlack
      };
    }

    return {
      status: 'default'
    };
  }, [active, dirty]);

  var goToPrevMonth = function goToPrevMonth(e) {
    e.stopPropagation();
    dispatch({
      type: 'NAVIGATE_MONTH',
      payload: 'subtract'
    });
  };

  var goToNextMonth = function goToNextMonth(e) {
    e.stopPropagation();
    dispatch({
      type: 'NAVIGATE_MONTH',
      payload: 'add'
    });
  };

  var setToday = function setToday(e) {
    e.stopPropagation();
    dispatch({
      type: 'SET_TODAY'
    });
  };

  var onAccept = function onAccept() {
    dispatch({
      type: 'ON_ACCEPT'
    });
    handleSelect(_moment["default"].utc(daySelected).toISOString());
  };

  var toggleActive = (0, _react.useCallback)(function () {
    dispatch({
      type: 'TOGGLE_ACTIVE'
    });
  }, [dispatch]);
  var monthTitle = month.locale(language).format(_lang["default"][language].month);
  return {
    active: active,
    dirty: dirty,
    currentValue: currentValue,
    weekItems: weekItems,
    calendarItems: calendarItems,
    onChange: onChange,
    onFocus: onFocus,
    isNotFirstDayOfMonth: month.isAfter((0, _moment["default"])().startOf('month')),
    goToPrevMonth: goToPrevMonth,
    goToNextMonth: goToNextMonth,
    currentStatus: currentStatus,
    monthTitle: monthTitle,
    setToday: setToday,
    onAccept: onAccept,
    toggleActive: toggleActive
  };
};

var _default = useCalendar;
exports["default"] = _default;